import { useState, useRef } from "react";
import "./App.css";
export default function Loader(props) {
  return (
    <>
      <div
        className="loadingContainer"
        style={{
          display: props.loading ? "flex" : "none",
        }}
      >
        <div className="loading"></div>
      </div>
    </>
  );
}
